import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UICallHistoryItem } from '../../models/company-call-history/company-call-history.model';
import { StartCallOutput, StartCallOutputType } from '../start-call-modal/start-call-modal.model';
import { StartCallModalComponent } from '../start-call-modal/start-call-modal.component';
import { UtilsService } from '../../services';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CallService } from '../../../core/services';
import { IPhoneCallTag, PhoneCallDirections, PhoneCallTypes } from 'voxloud-types/dist/models/call-history/call-event.model';
import { CompanyCallHistoryDetailComponent } from '../company-call-history-detail/company-call-history-detail.component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'company-call-history-table',
  templateUrl: './company-call-history-table.component.html',
  styleUrls: ['./company-call-history-table.component.scss']
})
export class CompanyCallHistoryTableComponent {
  @Output() fetchTags: EventEmitter<void> = new EventEmitter();
  @Input() callHistory: UICallHistoryItem[] = [];
  @Input() loading: boolean = false;
  @Input() set loadingRows(v: number) {
    if(v) {
      this.skeletonRows = [];
      for(let i = 0; i < v; i++){
        this.skeletonRows.push(i);
      }
    }
  };
  @Input() set allTags(v: IPhoneCallTag[]) {
    this._allTags = v;
    if (this.activeModalRef) this.activeModalRef.componentInstance.allTags = v;
  }
  @Input() set tagsApiFailed(v: boolean) {
    this._tagsApiFailed = v;
    if (this.activeModalRef) this.activeModalRef.componentInstance.tagsApiFailed = v;
  }
  public _allTags: IPhoneCallTag[];
  public _tagsApiFailed: boolean = false;
  public skeletonRows: number[] = [0, 1, 2, 3, 4];
  public PhoneCallDirections = PhoneCallDirections;
  public dateFormat = {
    short: 'MM/dd/yy HH:mm',
    long: 'MMM dd yyyy HH:mm:ss'
  };
  public language: string = 'it';
  public PhoneCallTypes = PhoneCallTypes

  private languageSubscription: Subscription;
  private activeModalRef: NgbModalRef | null = null;

  constructor(
        private utilsService: UtilsService,
        private modalService: NgbModal,
        private callService: CallService,
        private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.language = this.translateService.currentLang;
    this.languageSubscription = this.translateService.onLangChange.subscribe((language: string) => {
      this.language = language;
    });
  }

  ngOnDestroy() {
    this.languageSubscription?.unsubscribe();
  }

  public openLink(link: string) {
      this.utilsService.openExternalLink(link);
    }
  
    public openStartCallModal(number: string): void {
      const modalRef = this.modalService.open(StartCallModalComponent, {
        backdrop: 'static'
      });
  
      modalRef.componentInstance.currentDigitedValue = number;
  
      modalRef.result.then((result: StartCallOutput) => {
        if(!result) return; // closed by the X
        switch(result.type) {
          case StartCallOutputType.NUMBER:
            this.callService.callFromNumber(result.number);
            break;
          case StartCallOutputType.INTERNAL_USER:
          case StartCallOutputType.INTERNAL_GROUP:
          case StartCallOutputType.EXTERNAL_VCARD:
            this.callService.callFromRecord(result.contact, result.contact.defaultNumber.number);
            break;
          case StartCallOutputType.EVENT:
            this.callService.callFromEvent(result.contact);
            break
        }
      })
  }

  public openCallDetail(callItem: UICallHistoryItem) {
    const modalRef = this.modalService.open(CompanyCallHistoryDetailComponent, {
      size: 'lg',
      backdrop: 'static'
    });
    modalRef.componentInstance.callItem = callItem;
    modalRef.componentInstance.language = this.language;
    modalRef.componentInstance.allTags = this._allTags;
    modalRef.componentInstance.tagsApiFailed = this._tagsApiFailed;
    this.activeModalRef = modalRef;

    const fetchTagsSub = modalRef.componentInstance.fetchTags.subscribe(() => this.fetchTags.emit());
    modalRef.result.catch(() => {}).finally(() => {
      if (this.activeModalRef === modalRef) this.activeModalRef = null;
      fetchTagsSub.unsubscribe();
    });

    modalRef.componentInstance.updateCallLog.subscribe((callLogEvent: UICallHistoryItem) => {
      const idx = this.callHistory.findIndex(c => c.id === callLogEvent.id);
      if(idx > -1) this.callHistory[idx] = callLogEvent;
    });
  }

  public isNumber(v: number | string): boolean {
    return typeof v === 'number';
  }
}
